"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFreeTransfer = void 0;
const _ = require("lodash");
const hasFreeTransfer = (from, to, date, rates) => {
    if (!rates || rates.length === 0)
        return false;
    if (!from || !to || !date)
        return false;
    const rate = rates.filter((r) => {
        return (r.date === date &&
            ((r.from === from && r.to === to) || (r.from === to && r.to === from)));
    });
    if (!rate || rate.length === 0)
        return false;
    // if more than one rate, get the cheapest
    const cheapest_rate = _.minBy(rate, (item) => {
        const total = _.get(item, "rate.vehicle.total");
        return total === undefined ? Infinity : total;
    });
    return cheapest_rate.rate.vehicle.total === 0;
};
exports.hasFreeTransfer = hasFreeTransfer;
